<div class="layout-container fx-column fx-c-stretch-stretch">
  <app-navbar class="mat-elevation-z2"></app-navbar>

  <div class="content" id="scroll-anchor">
    <router-outlet (activate)="onScrollToTop($event)"></router-outlet>
  </div>
</div>
